import UIFormLabel from 'UIComponents/form/UIFormLabel';
import { useThemeStore } from 'academy-common-lib/utils/Styling';
import { ThemedToggle } from '../../../components/ThemedComponents';
import usageTracker from '../../../utils/usageTracker';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PublicPageThemeToggle = () => {
  const {
    theme,
    setTheme
  } = useThemeStore();
  return /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx(ThemedToggle, {
      checked: theme === 'highContrast',
      className: "m-right-2",
      id: "high-contrast-toggle",
      onChange: e => {
        if (e.target.checked) {
          setTheme('highContrast');
        } else {
          setTheme('light');
        }
        usageTracker.track('navInteraction', {
          action: 'theme-toggled',
          value: e.target.checked ? 'highContrast' : 'light'
        });
      },
      size: "small"
    }), /*#__PURE__*/_jsx(UIFormLabel, {
      htmlFor: "high-contrast-toggle",
      style: {
        fontWeight: 400
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "academyPublic.publicNav.highContrast"
      })
    })]
  });
};
export default PublicPageThemeToggle;